module.exports = __webpack_public_path__ + "a692b82e793a129f5cbf36feb56fbd1f.png";